<template>
  <button @click="confirmInput">Confirm</button>
  <button @click="changesSaved=!changesSaved">Save Changes</button>
  <ul>
    <user-item v-for="user in users" :key="user.id" :name="user.fullName" :role="user.role"></user-item>
  </ul>
</template>

<script>
import UserItem from '@/components/users/UserItem.vue';

export default {
  components: {
    UserItem,
  },
  inject: ['users'],
  data(){
      return {
          changesSaved: false
      }
  },
  methods:{
      confirmInput(){
        this.$router.push('/teams');
      }
  },
  beforeRouteEnter(to, from, next){
      console.log('UserList Cmp beforeRouteEnter')
      console.log(to, from)
      next()
  },
  beforeRouteLeave(to, from, next){
      console.log('UserList Cmp beforeRouteLeave')
      console.log(to, from)
      if ( this.changesSaved ){
          next();
      } else {
          const userWantsToLeave = confirm('이 페이지를 떠나면 저장되지 않은 데이터를 잃게 됩니다')
          next(userWantsToLeave)
      }
  },
  unmounted(){
      console.log('unmounted')
  }
};
</script>

<style scoped>
ul {
  list-style: none;
  margin: 2rem auto;
  max-width: 20rem;
  padding: 0;
}
</style>
